import {useDispatch, useSelector} from "react-redux";
import {appConfigSelector, rxSubmitSettingsCars} from "../../../slices/appSlice";
import {useState} from "react";
import useToast from "../../../util/useToast";
import {useTranslation} from "react-i18next";
import {updateSettingsCars} from "../../../api/ApiSettings";
import {selectAllAccounts} from "../../../slices/accountsSlice";
import {selectAllCategories} from "../../../slices/categoriesSlice";
import useNetwork from "../../../util/useNetwork";

const useSettingsCars = () => {
  const dispatch = useDispatch();

  const {showToastSuccess} = useToast();
  const {handleNetworkError} = useNetwork();
  const {t} = useTranslation("settings_cars");

  const accounts = useSelector(selectAllAccounts);
  const transactionCategories = useSelector(selectAllCategories);
  const {featureCarsActive, defaultCarsAccount, defaultCarsTransactionCategory} = useSelector(appConfigSelector);

  const [editedSettings, setEditedSettings] = useState({
    errors: {},
    featureCarsActive,
    defaultCarsAccount,
    defaultCarsTransactionCategory
  });

  const availableCategories = transactionCategories.filter(c => c.active || c.id === defaultCarsTransactionCategory);

  const availableAccounts = [{id: null, name: t("settings_cars_editor_choose_account")}]

  accounts.filter(a => a.active || a.id === defaultCarsAccount).forEach(a => availableAccounts.push(a));

  const submit = e => {
    e.preventDefault();

    dispatch(rxSubmitSettingsCars(editedSettings));

    updateSettingsCars(editedSettings).catch(handleNetworkError);

    showToastSuccess(t("toast_cars_editor_saved"));
  };

  const updateSettings = field => event => {
    const values = {};

    switch (field) {
      case "featureCarsActive":
      case "defaultCarsAccount":
      case "defaultCarsTransactionCategory":
        values[field] = event;
        break;
      default:
        values[field] = event.target.value;
        break;
    }

    setEditedSettings(prev => ({...prev, ...values}));
  };

  return {
    t,
    editedSettings,
    submit,
    updateSettings,
    availableAccounts,
    availableCategories
  };
};

export default useSettingsCars;
